import styled from 'styled-components';

const NoDataMessage = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;  
  font-size:1.5em;
  color: #aaa;
  z-index: -1;
`;

export default NoDataMessage;